/**
 * 和父页面通信
 */
// const path = require('path')

// const env = process.env.NODE_ENV
const MESSAGE_TYPE = {
  STATE_GO: 'stageGo',
  OPEN_TASK_DETAIL: 'openTaskDetail',
  CREATE_TASK: 'createTask',
  EXPORT_TASK_TO_CALENDAR: 'exportTaskToCalendar',
  VIEW_NEW_TASK_IN_LIST: 'viewNewTaskInList',
  RESET_TASK_TIME: 'updateTimeConfirm',
  SYNC_PROCESS_DATE: 'syncProcessDate',
  NOTICE_CENTER: 'noticeCenter',
  TOAST: 'toast',
  SENDUSERINFO: 'sendUserInfo',
  SETISREFRESH: 'setIsRefresh',
  LOCATION_SEARCH: 'locationSearch',
  FROM_WORK_FLAT_MY_TASK: 'fromWorkFlatMyTask',
  FROM_WORK_FLAT_MY_APPROVAL: 'fromWorkFlatMyApproval',
  FROM_WORK_FLAT_APPROVAL_DETAIL: 'fromWorkFlatApprovalDetail',
  FROM_WORK_FLAT_CONTRACT_DETAIL: 'fromWorkFlatContractDetail',
  FROM_WORK_FLAT_MATTER_DETAIL: 'fromWorkFlatMatterDetail'
}
// const parentURL = window.parent.location
const parentWindow = window.parent

function handlerPostMessage (message) {
  parentWindow.$$messageManage(message)
}
const messageManager = {
  /**
   * 父页面的路由跳转
   * 第二个参数 callback 传递 state.go 的路由参数
   */
  stateGo: (url, config) => {
    const message = {
      type: MESSAGE_TYPE.STATE_GO,
      content: url,
      callback: config
    }
    handlerPostMessage(message)
  },
  // 打开任务详情
  openTaskDetail: taskId => {
    const message = {
      type: MESSAGE_TYPE.OPEN_TASK_DETAIL,
      content: {
        taskId
      }
    }
    handlerPostMessage(message)
  },
  // 新建任务弹窗
  createTask: (message = {}, cb = () => {}) => {
    const _message = {
      type: MESSAGE_TYPE.CREATE_TASK,
      content: message,
      callback: cb
    }
    handlerPostMessage(_message)
  },
  // 导出任务到其他日历
  exportTaskToCalendar: () => {
    const message = {
      type: MESSAGE_TYPE.EXPORT_TASK_TO_CALENDAR,
      content: ''
    }
    handlerPostMessage(message)
  },
  // 查看新任务
  viewNewTaskInList: taskIds => {
    const message = {
      type: MESSAGE_TYPE.VIEW_NEW_TASK_IN_LIST,
      content: taskIds
    }
    handlerPostMessage(message)
  },
  // 修改任务的时间
  syncProcessDate: (params, cb) => {
    const message = {
      type: MESSAGE_TYPE.SYNC_PROCESS_DATE,
      content: params,
      callback: cb
    }
    handlerPostMessage(message)
  },
  // 修改任务的时间
  resetTaskTime: (params, cb) => {
    const message = {
      type: MESSAGE_TYPE.RESET_TASK_TIME,
      content: params,
      callback: cb
    }
    handlerPostMessage(message)
  },
  // 通知中心事件通信
  noticeCenterCommunication (content, callback) {
    const message = {
      type: MESSAGE_TYPE.NOTICE_CENTER,
      content: content,
      callback: callback
    }
    handlerPostMessage(message)
  },
  toast (content, callback) {
    const message = {
      type: MESSAGE_TYPE.TOAST,
      content: content,
      callback: callback
    }
    handlerPostMessage(message)
  },
  sendUserInfo (content) {
    const message = {
      type: MESSAGE_TYPE.SENDUSERINFO,
      content
    }
    handlerPostMessage(message)
  },
  setIsRefresh (isRefresh) {
    const message = {
      type: MESSAGE_TYPE.SETISREFRESH,
      content: {
        isRefresh
      }
    }
    handlerPostMessage(message)
  },
  locationSearch (params) {
    const message = {
      type: MESSAGE_TYPE.LOCATION_SEARCH,
      content: params
    }
    handlerPostMessage(message)
  },
  // 跳转到我的任务
  fromWorkFlatMyTask  (params) {
    const message = {
      type: MESSAGE_TYPE.FROM_WORK_FLAT_MY_TASK,
      content: params
    }
    handlerPostMessage(message)
  },
  // 跳转到我的审批
  fromWorkFlatMyApproval (params) {
    const message = {
      type: MESSAGE_TYPE.FROM_WORK_FLAT_MY_APPROVAL,
      content: params
    }
    handlerPostMessage(message)
  },
  // 跳转到审批详情
  fromWorkFlatApprovalDetail (content, callback) {
    const message = {
      type: MESSAGE_TYPE.FROM_WORK_FLAT_APPROVAL_DETAIL,
      content: content,
      callback: callback
    }
    handlerPostMessage(message)
  },
  // 跳转到合同详情
  fromWorkFlatContractDetail (content, callback) {
    const message = {
      type: MESSAGE_TYPE.FROM_WORK_FLAT_CONTRACT_DETAIL,
      content: content,
      callback: callback
    }
    handlerPostMessage(message)
  },
  // 跳转到项目详情
  fromWorkFlatMatterDetail (content, callback) {
    const message = {
      type: MESSAGE_TYPE.FROM_WORK_FLAT_MATTER_DETAIL,
      content: content,
      callback: callback
    }
    handlerPostMessage(message)
  }
}

export default messageManager
